var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.1,
    height: 95.1,
    viewBox: "0 0 95.1 95.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(-1070.5 -2544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(1068 2541.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M80.3,33.4a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8L70.3,16a2.687,2.687,0,1,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M80.3,53.7a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8L50.1,16a2.687,2.687,0,0,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M80.3,73.9a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8L29.9,16a2.687,2.687,0,1,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M70.1,84a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8L19.7,26.1a2.687,2.687,0,0,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M49.9,84a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8l-34-33.9a2.687,2.687,0,0,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M29.7,84a2.656,2.656,0,0,0,3.8,0,2.781,2.781,0,0,0,0-3.8L19.7,66.6a2.687,2.687,0,0,0-3.8,3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M94.8,2.5H5.2A2.689,2.689,0,0,0,2.5,5.2V94.9a2.689,2.689,0,0,0,2.7,2.7H94.9a2.689,2.689,0,0,0,2.7-2.7V5.2A2.843,2.843,0,0,0,94.8,2.5ZM92.2,92.2H7.8V7.8H92.1V92.2Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishes);
export default __webpack_public_path__ + "static/media/finishes.14165bc5d1fbb9a2052c03c8045cfe76.svg";
export { ForwardRef as ReactComponent };